export interface Banner {
  appGoUrl: number;
  appPicUrl: string;
  subtitle: string;
  title: string;
  webGoUrl: string;
  webPicUrl: string;
}

export interface RuleConfig {
  activityTag: string;
  lotteryEndTime: number;
  lotteryStartTime: number;
  redeemEndTime: number;
  redeemStartTime: number;
  registrationEndTime: number;
  registrationStartTime: number;
  snapshotEndTime: number;
  snapshotStartTime: number;
  activityStartTime?: number;
  activityEndTime?: number;
}

export enum ActivityType {
  Staking = 1,
  IDO = 2,
  NFT = 3,
  Inscription = 4,
  AirDrip = 5,
  Metropolis = 6,
  Points = 7,
  DexPro = 8,
  Swap = 9,
  WSOT = 10,
}

export interface Activity {
  activityDesc: string;
  activityDetail: string;
  activityName: string;
  activityRuleConfig: RuleConfig;
  // 1-Staking，2-IDO，3-NFT，4-铭文，5-AirDrip，6-Metropolis
  activityType: ActivityType;
  appGoUrl: string;
  appPicUrl: string;
  endTime: number;
  sequence: number;
  startTime: number;
  webGoUrl: string;
  webPicUrl: string;
}

export interface HomeConfigData {
  activityModuleData: Activity[];
  bannerData: Banner[];
  dappModuleData: DappModuleDataType[];
}

export interface LearnData {
  title: string;
  summary: string;
  pid: string;
}

export interface NoticeItem {
  appGoUrl: string;
  content: string;
  endTime: number;
  id: number;
  startTime: number;
  title: string;
  webGoUrl: string;
}

export interface TokenRankItem {
  total: number;
  tokenId: number;
  tokenName: string;
  tokenSymbol: string;
  tokenLogo: string;
  tokenPrice: string;
  tokenVolume24h: string;
  percentChange24h: string;
}

export interface DApp {
  dappId: number;
  name: string;
  logo: string;
  website: string;
  description: string;
  chains: string[];
  categories: string[];
}

export type DAppList = DApp[];

type DAppData = {
  data: DAppList;
};

export interface DappModuleDataType {
  dappModuleId: number;
  dappData: DAppData;
  moduleName: string;
  sequence: number;
}

export type TokenDetail = {
  chainId: number;
  tokenId: number;
  tokenName: string;
  symbol: string;
  decimals: number;
  icon: string;
  address: string;
  price: string;
  priceChange: string;
  priceHigh: string;
  priceLow: string;
  volume: string;
  liquidity: string;
};
